export const validateURL = (value: string) => {
  const isValid = /^(https?:\/\/)(www\.)([a-z0-9]+)(\.[a-z]{2,3})$/.test(value)

  let error: string | null = null
  if (!isValid) error = 'e.g. https://www.vynedental.com'

  if (error) return Promise.reject(new Error(error))
  else return Promise.resolve()
}
